export default "/images/welcome-img-mobile1.png";